import { ChangeEventHandler } from "react";
import { css, cva } from "../../../../styled-system/css";
import svgExpandMoreOutlined from "../../../assets/icons/expandMoreOutlined.svg";

const select = cva({
  base: {
    bgColor: "background.primary",
    paddingLeft: "24px",
    width: "100%",
    height: "48px",
    textStyle: "button.s",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "border.secondary",
    borderRadius: "4px",
    appearance: "none",
    outline: "none",
    cursor: "pointer",
  },
  variants: {
    isChipsTextExist: {
      true: {},
      false: {
        paddingRight: "36px",
      },
    },
    chipsWidthKey: {
      // NOTE: chipsTextの文字数（Chipsのwidth）によってpaddingRightが変わる。
      // NOTE: w_62というkeyは適当で例として記述している。実際に使われるかどうか不明。必要なければ削除する。
      w_62: {
        // paddingRightはChipsのwidthに16px加算した値
        paddingRight: "78px",
      },
      none: {},
    },
  },
});

type ChipsProps =
  | {
      chipsText?: undefined;
      chipsWidthKey?: undefined;
    }
  | {
      chipsText: string;
      chipsWidthKey: "w_62";
    };

interface SelectOption {
  label: string;
  value: string;
}

export type SelectInputProps = {
  id: string;
  value: string | undefined;
  options: SelectOption[];
  onChange: ChangeEventHandler<HTMLSelectElement>;
} & ChipsProps;

export function SelectInput({
  id,
  value,
  options,
  chipsText,
  chipsWidthKey,
  onChange,
}: SelectInputProps) {
  const rightContent = css({
    display: "flex",
    position: "absolute",
    top: "12px",
    right: "8px",
    pointerEvents: "none",
  });

  return (
    <div className={css({ position: "relative" })}>
      <select
        id={id}
        value={value}
        className={select({
          isChipsTextExist: chipsText ? true : false,
          chipsWidthKey: chipsWidthKey ?? "none",
        })}
        onChange={onChange}
      >
        <option hidden />
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <img src={svgExpandMoreOutlined} alt="" className={rightContent} />
    </div>
  );
}
